module.exports = __webpack_public_path__ + "static/media/location-001760.5a2fcf9a.svg";